<template>
  <div class="relative" :class="{ 'w-full': fullWidth }" :title="disabled ? disabledTooltip : null">
    <!-- Trigger Box -->
    <div
        :class="[
          'relative custom-dropdown-trigger group flex items-center h-[44px] px-4 rounded-md border text-sm transition-colors',
          disabled
            ? `${bgColor} ${disabledTextColor} cursor-not-allowed`
            : `${bgColor} ${textColor} ${hoverBgColor} cursor-pointer`,
          borderColor,
          { 'w-full': fullWidth },
        ]"
        @click="open"
    >
      <!-- Left Icon -->
      <i v-if="leftIcon" :class="['bi', leftIcon, 'text-lg mr-2']"/>

      <!-- Display Text -->
      <span class="flex-1 truncate select-none">
  {{
          modelValue && typeof modelValue === 'object'
              ? modelValue.label
              : modelValue || placeholder
        }}
</span>

      <!-- Right-Side Icon Area -->
      <div class="absolute right-4 flex items-center">
        <i v-if="clearable && modelValue" @click.stop="emit('clear')"
           class="bi bi-x-lg text-base text-base-content/50 hover:text-error"></i>
        <i
            v-else-if="rightIcon"
            :class="['bi', rightIcon, 'text-lg',disabled ? disabledTextColor : '']"
        />
      </div>
    </div>

    <!-- Inline Dropdown Panel -->
    <div v-if="show" class="absolute left-0 right-0 z-50 mt-1">
      <!-- Click-away overlay (transparent) -->
      <div class="fixed inset-0 z-40" @click="close"></div>
      <!-- Dropdown content -->
      <div
          :class="['relative z-50 bg-white border border-base-300 rounded-lg shadow-lg', autoHeight ? '' : 'max-h-[300px] overflow-auto']"
      >
        <div class="w-full">
          <slot :close="close" :open="open"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {nextTick, ref} from 'vue'

const props = defineProps({
  placeholder: {type: String, default: 'Select…'},
  leftIcon: String,
  rightIcon: {type: String, default: "bi-chevron-down"},
  clearable: Boolean,
  disabled: Boolean,
  fullWidth: {type: Boolean, default: true},
  disabledTooltip: {type: String, default: 'This field is disabled'},
  bgColor: {type: String, default: 'bg-base-100'},
  hoverBgColor: {type: String, default: 'hover:bg-base-200'},
  borderColor: {type: String, default: 'border-base-300'},
  textColor: {type: String, default: 'text-base-content/70'},
  disabledTextColor: {type: String, default: 'text-base-content/20'},
  autoHeight: {type: Boolean, default: false},
})

const emit = defineEmits(['clear', 'opened'])

const modelValue = defineModel({type: [String, Date, Number, Object, null], default: null})

const show = ref(false)

const close = () => {
  show.value = false
}

const open = () => {
  if (!props.disabled) {
    show.value = true
    emit('opened')
  }
}

defineExpose({close, open})
</script>
